<template>
  <div class="draft-all">
    <div @click.stop="showdraft" class="flex-lm" style="cursor: pointer;">
      <lastday v-if="draftinfo" :detail="draftinfo"></lastday>
      <div class="black-font font-size14 draft-title font-more" style="max-width: 230px;">#{{name}}</div>
      <div class="">
        <img src="https://assets.pfotoo.com/pc/img/click.png"/>
      </div>
    </div>
    <div class="line bg-gray"></div>
    <div :class="['draft-cover bg-gray',draftHidden ? '' : 'active']"
         :style="{border:draftHidden ? 0 : '1px solid #e0e0e0',
         height:draftHidden ? 0 : collectminheight+'px',
         maxHeight:draftHidden ? 0 : collectminheight+'px',}">
      <div class="activity-menu-list flex-lm">
        <div v-for="(item,index) in statuslist" :class="['activity-menu', item.isactive==true ? 'black-font' : 'gray-font', 'font-size16']">{{item.name}}</div>
      </div>
      <list :scrolltop="scrolltop" v-on:getdraftid="getdraftid" action="select"></list>
    </div>
  </div>
</template>

<script>
  import App from '../util/comfun'
import list from './list.vue'
import lastday from './dialog/draft-lastday.vue'
export default{
    name:'draftcover',
    props:{

    },
    data (){
      return {
        statuslist:[
          {
            name:'全部',
            status:0,
            isactive:true
          },
        ],
        draftHidden:true,
        name:'',
        collectminheight:window.innerHeight-127,
        scrolltop:0,
        draftinfo:null,
        buyStorageUrl:'',
      }
    },
    components:{
      list,
      lastday,
    },
    methods:{
      unixtoTime:App.unixtoTime,
      showdraft(){
        this.draftHidden=false;
      },
      closedraft(){
        console.log('dddddd')
        this.draftHidden=true;
      },
      handleScroll(){
        let scrollTop = $('.draft-cover')[0].scrollTop;
        if(!this.draftHidden){
          this.scrolltop=scrollTop;
        }
      },
      getdraftid(obj){
        this.$emit('getdraftid',obj);
        this.name=obj.name;
        //console.error('getdraftid',obj)
        this.getDetail(obj)
      },
      getDetail(obj){
        if(!obj.id) return;
        App.demand('/activity/detail/'+obj.id,'GET').then(res=>{
          this.draftinfo=res.data;
          this.buyStorage()
        })
      },
      getH5params(key=''){
        let params={};
        params[key]=encodeURIComponent(JSON.stringify({
          userId:wxlite.getStorageSync('userId'),
          //hasInBusiness:wxlite.hasInBusiness?1:0,

          from:'pc',
          token:wxlite.getStorageSync('token'),
          uid:this.draftinfo.createBy}));
        return App.getH5({
          ...params,
          '_':'',
        },'');
      },
      buyStorage(){
        this.buyStorageUrl=this.getH5params('buy-storage')
      },
    },
    mounted(){
      $('.draft-cover')[0].addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style>
  .draft-all{
    width: 100%;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    padding-left: 10px;
  }
  .draft-title{
    height: 45px;
    line-height: 45px;
    margin-right: 10px;
    padding-left: 10px;
    box-sizing: border-box;
    opacity: .8;
  }
  .draft-cover{
    width: 100%;
    position: absolute;
    left:0;
    top:46px;
    max-height: 0;
    overflow-y: hidden;
    transition: max-height .4s ease;
  }
  .draft-cover.active{
    padding-top:30px;
    height:600px;
    max-height: 600px;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .draft-list{
    padding-top:20px;
  }
  .activity-menu {
      padding: 0 5px;
      margin-right: 5px;
      cursor: pointer;
  }
  .activity-menu-list{
    width: 100%;
    padding-left:10px;
    box-sizing: border-box;
  }
  .line{
    width: 100%;
    height: 1px;
    opacity: .8;
  }
  .draftinfo-activity-clean{
      width: 87px;
      height: 25px;
      background-image: linear-gradient(-88deg, #F5515F 0%, #D87D25 100%);
      border-radius: 5px;

      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
  }
    .buy-storage-but{
        width: 170px;
        height: 40px;
        background: #3DC4A7;
        border-radius: 30px;

        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        margin: 10px auto 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/draftcover.vue